import { Component } from '@angular/core';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'app-success-step-v0',
  templateUrl: './success-step.component.html',
  styleUrls: ['./success-step.component.scss']
})
export class SuccessStepComponentV0 {

  constructor(
    private resourceService: ADPResourceService
  ) { }

  navigateToLogin() {
    const loginRoute = this.resourceService.getPortalSetting('URL_Login').Value;
    location.replace(loginRoute);
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }
}
